import React from "react";
import imageDepard from './images/depart_outils.png';
import imageQuiz from './images/cartes-jeu.png';
import Carte from './images/cartegame.jpg';
import ImageBlanc from './images/imgbranco.png';
import imagepassarelle from './images/background_transparent.png'
/* import ImageCarte from './images/carte-transparente.png'
 */import ImageBackground from './images/background_transparent.png';
import ImageCarte from './images/monopoly_outils.png';
import Chaise from './images/chaise_bientot.png';
import './Carrosel.css';
import './outils.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion, faClose, faHourglass, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';

const Outils = ()=>{
    const imgPath = process.env.PUBLIC_URL + "/images/monopoly_quiz.png"; 


    return(
        <>
        <div className="envelope-outils">
         {/*    <div className="outils-banner">
                <div className="description-title">

                </div>
            </div> */}
                 <div className="banner-oultils">
                 <div className="poster_onglet_700">
          
          </div>
                    <div className="poster_onglet_outils">
                        <div className="description-title">
{/*                             <p20>Outils</p20>
 */}                        </div>
                    </div>
                </div>
              {/*   <div className="title-description_outils_novo"><p className="text-citation">Outils</p></div> */}

            <div className="grid-container-outils">

{/*                 <div className="title-description_outils"><p20>Outils</p20></div>
 */}           
                <div className="grid-item-outils" id="grid1-outils">
                    <a href="/pdf/50-cartes.pdf" download="50-cartes.pdf">

                    <div className="image-container">
                     <img src={imageQuiz}></img>

                    </div>
                    </a>

                    <div className="container-outils-button">
                        <a href="/pdf/50-cartes.pdf" download="50-cartes.pdf">
                        <button className="outils-button">Téléchargez les 50 cases de la carte associative </button>

                            
                        </a>

                    </div>

                </div>

                <div className="grid-item-outils" id="grid2-outils">
                  <a href="/pdf/plateau-de-jeu-2025.pdf" download="plateau-de-jeu-2025.pdf">

                    <div className="image-container-carte">
                    <img src={ImageCarte}></img>

                    </div>
                    </a>
 
                    <div className="container-outils-button">
{/*                     <a href={imgPath} download="/monopoly_quiz.png">
 */}            
                    <a href="/pdf/plateau-de-jeu-2025.pdf" download="plateau-de-jeu-2025.pdf">

                    <button className="outils-button">Téléchargez la carte associative </button>
                    </a>

 
                    </div>

                </div>

                <div className="grid-item-outils" id="grid3-outils">
                    <a href="/pdf/quiz-Q&R.pdf" download="quiz-Q&R.pdf">

                    <div className="image-container">
                       <button className="btn-outils">
                                    <FontAwesomeIcon icon={faQuestion} className="icon-outils" />
                                  </button>
                      <img src={imagepassarelle}></img>

                    </div>
                    </a>
                    <div className="container-outils-button">
                    <a href="/pdf/quiz-Q&R.pdf" download="quiz-Q&R.pdf">
    
                    <button className="outils-button">Téléchargez les cartes questions de la carte associative</button>
                    </a>
                    </div>

                </div>
                <div className="grid-item-outils" id="grid4-outils">
                    <div className="image-container prochain">
                      {/*   <div className="description-box">
                          <p className="description-text"></p>
                        </div> */}
                   
                        <img src={Chaise}></img>


                    </div>
                    <div className="container-outils-button">
                    <button className="outils-button">Atelier d’information-sensibilisation</button>
 
                    </div>
                </div>
            </div>
        </div>

        </>

    );
}
export default Outils;